
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum ReasonType {
	None = 0,
	Termination = 1,
	Settlement = 2,
	Objection = 4,
	OrderCancellation = 8,
	OrderWarning = 16,
	Discount = 32
}
export namespace ReasonType {
	export function getKeys(): Map<ReasonType, string> {
		return new Map([[0, 'None'], [1, 'Termination'], [2, 'Settlement'], [4, 'Objection'], [8, 'OrderCancellation'], [16, 'OrderWarning'], [32, 'Discount']]);
	}
}
